import React from 'react'
import style from './style.module.sass'
import { NavLink } from 'react-router-dom'
import arrowTop from './assets/arrorTop.svg'
import arrowTopDark from './assets/arrorTopDark.svg'
import rightArrow from './assets/rightArrow.svg'
import { useTheme } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import CheckIcon from '@material-ui/icons/Check'
import { Tooltip } from '@material-ui/core'
import { stripHtml } from '../../../utils'
import config from '../../../config'
import { Close, Info, Warning } from '@material-ui/icons'

function Notification ({ open, setOpen, handleMarkRead }) {
  const { theme: { bgColors, borderColors, colors } } = useTheme()
  const { t } = useTranslation()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT

  // get reducers
  const messages = useSelector(state => state.userData.messages.getWarningsAndInfo())
  const theme = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const triangleImg = theme === config.THEMES_MODES.CONTRAST_DARK ? arrowTopDark : arrowTop
  return (
    <div
      style={{ backgroundColor: bgColors.bgBoxes, transform: open ? 'translateY(10px)' : 'translateY(-1200px)', color: colors.colorText}}
      className={style.select}>
      <img className={style.triangle} src={triangleImg} alt=""/>

      <div onClick={() => setOpen(false)} style={{ borderBottomColor: borderColors.borderPrimary700}}
           className={`d-flex align-items-center pb-1 text-left btn ${style.options}`}>
        <Close className="mr-2 ml-0" style={{ backgroundColor: bgColors.bgPrimary200, padding: 3, borderRadius: '50%', cursor: 'pointer', color: colors.colorIcons, fontSize: '18px'}} />
        <p className={`m-0`} style={{color: colors.colorText}}>{t('Notifications')}</p>
      </div>
      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
        {(messages && messages[0]?.length) ? messages[0].reverse().map((o, i) => (
          <div style={{ borderColor: borderColors.borderPrimary300, gridGap: '5px'}} key={o.id} className={`d-flex align-items-center justify-content-between ${style.options}`}>
          <div className={`d-flex align-items-center`}>
            {
              o?.level === 'info' ? <Info style={{ marginRight: '10px', color: colors.colorBlue1000 }} /> : <Warning style={{ marginRight: '10px', color: colors.colorStatusError }} />
            }
          <NavLink
            onClick={() => setOpen(false)}
            to={`/profile/messages/${o.id}#${o.id}`}
            tabIndex={-1}
            aria-label={stripHtml(o.header)}
            exact={true}>
            <p style={{ color: colors.colorPrimary1000, minWidth: '266px'}} className={`m-0`}>
              {stripHtml(o.header).substring(0, 40)} {stripHtml(o.header).length > 40 ? '...' : ''}
            </p>
          </NavLink>
          </div>
          <div className='d-flex align-items-center' style={{gridGap: '5px'}}>
          <NavLink
            onClick={() => setOpen(false)}
            to={`/profile/messages/${o.id}#${o.id}`}
            aria-label={t('notifications_open')}
            tabIndex={open? config.tabIndexes.notificationButtonMessage + i : -1}
            exact={true}>
            <Tooltip>
              <img className={style.arrowRight} src={rightArrow} alt={t('notifications_open')}/>
            </Tooltip>
          </NavLink>

          <Tooltip style={{ cursor: 'pointer' }} title={t('notifications_make_read')}>
            <span tabIndex={open? config.tabIndexes.notificationButtonMessageTick + i : -1} onClick={() => handleMarkRead(o.id)} alt={t('notifications_make_read')}>
            <CheckIcon />
            </span>
          </Tooltip>
          </div>
        </div>

      )) : <div className={style.no_messages}>{t('notifications_no_unread_messages')}</div>}
      </div>
      <div className={style.link} style={{boxShadow: `0 -2px 0px ${borderColors.borderPrimary300}`}}>
        <NavLink
          style={({ isActive }) => ({ color: isContrast && 'inherit', fontWeight: (isActive && isContrast) ? "bold" : "normal" })}
          onMouseOver={(e) => (e.currentTarget.style.fontWeight = "bold")}
          onMouseOut={(e) => (e.currentTarget.style.fontWeight = "normal")}
          tabIndex={open ? config.tabIndexes.notificationButtonMessageOverview : -1} alt="" to="/profile/messages">{t('notifications_message_link')}</NavLink>
      </div>
    </div>
  )
}

export default Notification
